import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getLoginPromptMessage } from '../config/featureConfig';
import './LoginPrompt.css';

const LoginPrompt = ({ message, onClose, feature, subFeature }) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  
  if (isAuthenticated) {
    return null;
  }
  
  const promptMessage = message || getLoginPromptMessage(feature, subFeature) || "Please login to access this feature.";
  
  const handleLogin = () => {
    onClose();
    navigate('/login');
  };

  return (
    <div className="login-prompt-overlay" onClick={onClose}>
      <div className="login-prompt" onClick={(e) => e.stopPropagation()}>
        <h3>Login Required</h3>
        <p>{promptMessage}</p>
        <div className="login-prompt-buttons">
          <button className="login-button" onClick={handleLogin}>
            Go to Login
          </button>
          <button className="cancel-button" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPrompt;

